export const buildRefreshTokenRequestParams = (
  refreshToken: string,
  clientId: string,
): URLSearchParams => {
  const tokenParams = new URLSearchParams();
  tokenParams.append('grant_type', 'refresh_token');
  tokenParams.append('refresh_token', refreshToken);
  tokenParams.append('client_id', clientId);
  return tokenParams;
};
